import { ERoleType } from "../enum";
import { ListUsersDto } from "../types/dto/ListUsersDto";
import { ListDto } from "../types/dto/ListDto";
import { ApiService } from "./apiService";

export const getUsers = async (dto: ListUsersDto) => {
    return await ApiService.get(`users?page=${dto.page}&size=${dto.size}&name=${dto.name}&status=${dto.status}&role=${dto.role}`)
}

// Accounts refused for opening too many products, the latest first.
export const getFlaggedUsers = async (dto: ListDto) => {
    return await ApiService.get(`users/flagged?page=${dto.page}&size=${dto.size}`)
}

export const updateUserRole = async (userId: string, role: ERoleType) => {
    return await ApiService.patch(`users/${userId}/role`, { role });
}

export const updateCanSuggestProducts = async (userId: string, canSuggestProducts: boolean) => {
    return await ApiService.patch(`users/${userId}/can-suggest-products`, { canSuggestProducts });
}

// With the account's phones the admin chose to block along with it.
export const blockUser = async (endUserId: string, deviceIds: string[]) => {
    return await ApiService.post(`users/${endUserId}/block`, { deviceIds });
}

export const unblockUser = async (endUserId: string) => {
    return await ApiService.post(`users/${endUserId}/unblock`, {});
}